/**
 * Загружает все страницы API с контрактом:
 *
 * {
 *   total: number,
 *   items: []
 * }
 *
 * fetchPage получает:
 * {
 *   limit,
 *   offset
 * }
 */
export async function fetchAllPages(
  fetchPage,
  {
    pageSize = 500,
    maxPages = 1000,
  } = {},
) {
  const result = [];

  let offset = 0;

  for (let page = 0; page < maxPages; page += 1) {
    const data = await fetchPage({
      limit: pageSize,
      offset,
    });

    const items = Array.isArray(data?.items) ? data.items : [];
    const total = Number(data?.total);

    result.push(...items);

    // API больше ничего не вернул — продолжать нельзя.
    if (items.length === 0) {
      return result;
    }

    // Offset увеличиваем на реально полученное количество строк,
    // а не на pageSize.
    offset += items.length;

    // Если total корректный и мы получили всю выборку — закончили.
    if (Number.isFinite(total) && result.length >= total) {
      return result;
    }

    // Если total отсутствует, короткую страницу считаем последней.
    if (!Number.isFinite(total) && items.length < pageSize) {
      return result;
    }
  }

  throw new Error(`fetchAllPages exceeded maxPages=${maxPages}`);
}
